import React from 'react';
import { motion } from 'framer-motion';
import { Youtube, Instagram } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-12 px-6 overflow-hidden" data-id="element-51">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-52">
        <img src="https://cdn.magicpatterns.com/uploads/xksjR6EH2a5pG2gtAQ3drj/Estudio_Final.png" alt="PampaNation Studio" className="w-full h-full object-cover object-center" data-id="element-53" />
        <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background" data-id="element-54"></div>
        <div className="absolute inset-0 bg-black/50" data-id="element-55"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center mt-12" data-id="element-56">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-5xl md:text-7xl font-serif font-bold text-white mb-6 leading-tight" data-id="element-57">
          Rock argentino 80/90.
          <br data-id="element-58" />
          <span className="text-amber-400 italic font-normal" data-id="element-59">
            En vivo. De cerca.
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="text-lg md:text-xl text-gray-300 mb-10 max-w-2xl mx-auto leading-relaxed" data-id="element-60">
          Sesiones con clásicos de Soda Stereo, Fito Paez, Serú Girán y más.
          Sonido real, sin playback.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-61">
          <a href="https://www.youtube.com/@PampaNation" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 bg-amber-500 hover:bg-amber-400 text-background font-semibold px-8 py-4 rounded-full transition-all duration-300 w-full sm:w-auto justify-center" data-id="element-62">
            <Youtube className="w-5 h-5" data-id="element-63" />
            Ver en YouTube
          </a>
          <a href="https://www.youtube.com/@PampaNation?sub_confirmation=1" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border-2 border-amber-500/50 hover:border-amber-400 text-amber-400 hover:text-amber-300 hover:bg-amber-500/10 font-semibold px-8 py-4 rounded-full transition-all duration-300 w-full sm:w-auto justify-center" data-id="element-64">
            Suscribirme al canal
          </a>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="flex justify-center mb-8" data-id="element-65">
          <a href="https://www.instagram.com/pampanation" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 border-2 border-amber-500/50 hover:border-amber-400 text-amber-400 hover:text-amber-300 hover:bg-amber-500/10 font-semibold px-8 py-4 rounded-full transition-all duration-300" data-id="element-66">
            <Instagram className="w-5 h-5" data-id="element-67" />
            Seguir en Instagram
          </a>
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1,
        delay: 1
      }} className="text-sm text-gray-400/80 uppercase tracking-widest font-medium" data-id="element-68">
          Visto por fans del rock en español desde LatAm + USA.
        </motion.p>
      </div>
    </section>;
}